var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 144,
    viewBox: "0 0 203 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 31H69C64.0294 31 60 35.0294 60 40V104C60 108.971 64.0294 113 69 113H133C137.971 113 142 108.971 142 104V65.5",
    stroke: "#00ABC5",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.879 66.8787C99.7071 68.0503 99.7071 69.9497 100.879 71.1213C102.05 72.2929 103.95 72.2929 105.121 71.1213L100.879 66.8787ZM147 28C147 26.3431 145.657 25 144 25L117 25C115.343 25 114 26.3431 114 28C114 29.6569 115.343 31 117 31H141V55C141 56.6569 142.343 58 144 58C145.657 58 147 56.6569 147 55L147 28ZM105.121 71.1213L146.121 30.1213L141.879 25.8787L100.879 66.8787L105.121 71.1213Z",
    fill: "#00ABC5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/External.dbf0064786ea129959fb80bbeb398104.svg";
export { ForwardRef as ReactComponent };